import hopscotch from 'hopscotch';
import { clearStates, syncShellMenu } from './main';
import { createRooms } from './models/rooms/roomGeneration';
import { generateMeasurements } from './models/measurements/measurementGeneration';
import { newProject } from '../ui/events/uiEvents';
import { TransactionManager } from './TransactionManager';
import { t } from '../i18n';

// Define the tour configurations
const tourConfig = {
  de: {
    id: "hello-hopscotch",
    steps: [
      {
        title: "Hast du Lust auf eine Kennenlerntour durch unseren Konfigurator?!",
        content: "Beginne zunächst mit dem Platzieren von 4 Außenwänden.<br><br><b>Tipp:</b> Achte darauf, ein perfekt umschlossenes Rechteck zu bilden, da sonst die Dachplatzierung möglicherweise nicht funktioniert.",
        target: "#outerWallBtn",
        placement: "right",
        showCTAButton:true,
        ctaLabel:"Tour Beenden",
        onCTA: function() {
          cancelTour();
        },
        onShow: function() {
          disableAllControls();
          $('#outerWallBtn').removeClass('disabled');
        }
      },
      {
        title: "Gut gemacht",
        content: "Jetzt möchtest du wahrscheinlich ein paar Räume erstellen. Beginne mit dem Hinzufügen von 2 Innenwänden",
        target: '#innerWallBtn',
        placement: "right",
        onShow: function() {
          disableAllControls();
          $('#innerWallBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"Tour Beenden",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Great Job!",
        content: "Lass uns jetzt eine Haustür schaffen und diese in den Außenwänden platzieren. So kannst du dein neues Zuhause zu betreten",
        target: '#outsideDoorBtn',
        placement: "top",
        onShow: function() {
          disableAllControls();
          $('#outsideDoorBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"Tour Beenden",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Gut gemacht, Zeit zum Hinzufügen von Fenstern",
        content: "Lass uns ein Fenster erzeugen, damit du die schöne Natur draußen sehen kannst!",
        target: '#windowBtn',
        placement: "top",
        onShow: function() {
          disableAllControls();
          $('#windowBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"Tour Beenden",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Sehr gut, jetzt bitte eine Innentür platzieren",
        content: "Lass uns jetzt eine Innentür erstellen, um die geschaffenen Räume zu verbinden. Platziere die Tür, indem du mit der Maus über eine der Innenwände fährst und an der gewünschten Stelle per Mausklick das blau dargestellte Bauelement anfügst.",
        target: '#insideDoorBtn',
        placement: "top",
        onShow: function() {
         // $('#insideDoorBtn').trigger('click');
          disableAllControls();
          $('#insideDoorBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"Tour Beenden",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Fast fertig, zu guter Letzt erzeuge ein Dach für dein Projekt!",
        content: "Wähle die perfekte Einstellung für das Dach deines Projektes und lass den Konfigurator das Dachelement automatisch platzieren.<br><br><b>Tipp:</b> Wenn du Schwierigkeiten bei der automatischen Platzierung hast, versuche einmal die Manuelle.",
        target: '#roofBtn',
        placement: "right",
        onShow: function() {
          //$('#roofBtn').trigger('click');
          disableAllControls();
          $('#roofBtn').removeClass('disabled');
        }
      },
      {
        title: "Herzlichen Glückwunsch",
        content: "Du hast die Demo-Tour beendet! Genieße deine Zeit beim Bau deines Traumhauses!<br><br><b>Tipp:</b> Stelle sicher, dass du deine Projektänderungen regelmäßig speicherst.",
        target: '#save-project-btn',
        placement: "bottom",
        onShow: function() {
          localStorage.setItem("tourFinished", 1);
          enableAllControls();
        },
        showCTAButton:true,
        ctaLabel:"Tour Beenden",
        onCTA: function() {
          //cancelTour();
          localStorage.setItem("tourFinished", 1);
          hopscotch.endTour();
        }
      }
    ],
    onClose: function() {
      localStorage.setItem("tourFinished", 1);
      enableAllControls();
      if(hopscotch.getCurrStepNum() != 6)
        clearScene();
    }
  },
  en: {
    id: "hello-hopscotch",
    steps: [
      {
        title: "Would you like a tour of our configurator?!",
        content: "Start by placing 4 outer walls.<br><br><b>Tip:</b> Make sure to form a perfect enclosed rectangle, otherwise the roof placement may not work.",
        target: "#outerWallBtn",
        placement: "right",
        onShow: function() {
          //$('#outerWallBtn').trigger('click');
          disableAllControls();
          $('#outerWallBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"End Tour",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Well done",
        content: "Now you probably want to create some rooms. Start by adding 2 inner walls",
        target: '#innerWallBtn',
        placement: "right",
        onShow: function() {
         // $('#innerWallBtn').trigger('click');
          disableAllControls();
          $('#innerWallBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"End Tour",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Great Job!",
        content: "Let's create a front door and place it in the outer walls. This way you can enter your new home",
        target: '#outsideDoorBtn',
        placement: "top",
        onShow: function() {
          //$('#outsideDoorBtn').trigger('click');
          disableAllControls();
          $('#outsideDoorBtn').removeClass('disabled');
          
        }
      },
      {
        title: "Well done, time to add windows",
        content: "Let's create a window so you can see the beautiful nature outside!",
        target: '#windowBtn',
        placement: "top",
        onShow: function() {
          //$('#windowBtn').trigger('click');
          disableAllControls();
          $('#windowBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"End Tour",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Very good, now please place an interior door",
        content: "Let's create an interior door to connect the created rooms. Place the door by hovering over one of the interior walls and clicking at the desired location to attach the blue building element.",
        target: '#insideDoorBtn',
        placement: "top",
        onShow: function() {
          //$('#insideDoorBtn').trigger('click');
          disableAllControls();
          $('#insideDoorBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"End Tour",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Almost done, finally create a roof for your project!",
        content: "Choose the perfect setting for your project's roof and let the configurator place the roof element automatically.<br><br><b>Tip:</b> If you have difficulties with automatic placement, try the manual option.",
        target: '#roofBtn',
        placement: "right",
        onShow: function() {
          //$('#roofBtn').trigger('click');
          disableAllControls();
          $('#roofBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"End Tour",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Congratulations",
        content: "You have completed the demo tour! Enjoy your time building your dream house!<br><br><b>Tip:</b> Make sure to save your project changes regularly.",
        target: '#save-project-btn', // todo make this the save-project-btn in the dev branch
        placement: "bottom",
        onShow: function() {
          console.log("tour finished");
          localStorage.setItem("tourFinished", 1);
          enableAllControls();
        },
        showCTAButton:true,
        ctaLabel:"End Tour",
        onCTA: function() {
          localStorage.setItem("tourFinished", 1);
          hopscotch.endTour();
        }
      }
    ],
    onClose: function() {
      localStorage.setItem("tourFinished", 1);
      enableAllControls();
      if(hopscotch.getCurrStepNum() != 6)
        clearScene();
    }
  },
  fr: {
    id: "hello-hopscotch",
    steps: [
      {
        title: "Envie d'une visite guidée de notre configurateur ?",
        content: "Commencez par placer 4 murs extérieurs.<br><br><b>Conseil :</b> veillez à former un rectangle parfaitement fermé, sinon le placement du toit peut ne pas fonctionner.",
        target: "#outerWallBtn",
        placement: "right",
        onShow: function() {
          disableAllControls();
          $('#outerWallBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"Terminer la visite",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Bien joué",
        content: "Vous voulez maintenant probablement créer quelques pièces. Commencez par ajouter 2 murs intérieurs",
        target: '#innerWallBtn',
        placement: "right",
        onShow: function() {
          disableAllControls();
          $('#innerWallBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"Terminer la visite",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Excellent !",
        content: "Créons une porte d'entrée et plaçons-la dans les murs extérieurs. Vous pourrez ainsi entrer dans votre nouvelle maison",
        target: '#outsideDoorBtn',
        placement: "top",
        onShow: function() {
          disableAllControls();
          $('#outsideDoorBtn').removeClass('disabled');
        }
      },
      {
        title: "Bien joué, il est temps d'ajouter des fenêtres",
        content: "Créons une fenêtre pour que vous puissiez voir la nature à l'extérieur !",
        target: '#windowBtn',
        placement: "top",
        onShow: function() {
          disableAllControls();
          $('#windowBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"Terminer la visite",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Très bien, placez maintenant une porte intérieure",
        content: "Créons une porte intérieure pour relier les pièces. Placez la porte en survolant l'un des murs intérieurs et en cliquant à l'endroit souhaité pour fixer l'élément bleu.",
        target: '#insideDoorBtn',
        placement: "top",
        onShow: function() {
          disableAllControls();
          $('#insideDoorBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"Terminer la visite",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Presque terminé : créez enfin un toit pour votre projet !",
        content: "Choisissez le réglage idéal pour le toit de votre projet et laissez le configurateur placer l'élément de toit automatiquement.<br><br><b>Conseil :</b> si le placement automatique pose problème, essayez l'option manuelle.",
        target: '#roofBtn',
        placement: "right",
        onShow: function() {
          disableAllControls();
          $('#roofBtn').removeClass('disabled');
        },
        showCTAButton:true,
        ctaLabel:"Terminer la visite",
        onCTA: function() {
          cancelTour();
        }
      },
      {
        title: "Félicitations",
        content: "Vous avez terminé la visite de démonstration ! Bonne construction de votre maison de rêve !<br><br><b>Conseil :</b> pensez à enregistrer régulièrement les modifications de votre projet.",
        target: '#save-project-btn',
        placement: "bottom",
        onShow: function() {
          localStorage.setItem("tourFinished", 1);
          enableAllControls();
        },
        showCTAButton:true,
        ctaLabel:"Terminer la visite",
        onCTA: function() {
          localStorage.setItem("tourFinished", 1);
          hopscotch.endTour();
        }
      }
    ],
    onClose: function() {
      localStorage.setItem("tourFinished", 1);
      enableAllControls();
      if(hopscotch.getCurrStepNum() != 6)
        clearScene();
    }
  }
};

const disableAllControls = () => {
  $('.control-element').addClass('disabled');
  $('span.icon-button').addClass('disabled');
  
}

const enableAllControls = () => {
  $('.control-element').removeClass('disabled');
  $('span.icon-button').removeClass('disabled');
  syncShellMenu(true);
}

const locale = (document.documentElement.lang || "de").slice(0, 2).toLowerCase();
const tour = tourConfig[locale] || tourConfig.de;

if (localStorage.getItem("tourFinished") != 1) {
  startTour();
}


let isTourActive = () => {
  return hopscotch.getState() !== null;
}

function cancelTour() {
  hopscotch.endTour();
  localStorage.setItem("tourFinished",1);
  enableAllControls();
  clearScene();
}

function clearScene(){
  if(TransactionManager.undoStates.length > 0 && confirm(t("confirm_clear_scene")))
    newProject();
}


var elEvents = {
  outerWindows:0,
  outerWalls:0,
  innerWalls:0,
  roofPlacement:0,//test
  interiorDoor:0,
  exteriorDoor:0,
  window:0,
  cutOut:0
}

export function startTour() {
  elEvents = {
    outerWindows:0,
    outerWalls:0,
    innerWalls:0,
    roofPlacement:0,//test
    interiorDoor:0,
    exteriorDoor:0,
    window:0,
    cutOut:0
  }
  hopscotch.configure({showNextButton: false, showPrevButton: false});
  localStorage.setItem("tourFinished", 0);
  hopscotch.startTour(tour, 0);
}

export function isActiveTour() {
  return hopscotch.getState() !== null
}

$('#outerWallBtn').on('wallCreated', function (e, type) {
  if(!isTourActive())
    return;
  //console.log("outerwall btn called: " + type);
  //console.log("step: " + hopscotch.getCurrStepNum());
  elEvents[type]++;

  if (hopscotch.getCurrStepNum() == 0 && elEvents.outerWalls >= 4) { //outside walls
    createRooms().then();
    generateMeasurements().then();
    hopscotch.nextStep();
    clearStates();
  }
  if (hopscotch.getCurrStepNum() == 1 && elEvents.innerWalls >= 2) { //inner walls
    createRooms().then();
    generateMeasurements().then();
    hopscotch.nextStep();
    clearStates();
  }
  if (hopscotch.getCurrStepNum() == 2 && elEvents.exteriorDoor >= 1) { //outer door
    hopscotch.nextStep();
    clearStates();
  }
  if (hopscotch.getCurrStepNum() == 3 && elEvents.window >= 1) { //windows
    hopscotch.nextStep();
    clearStates();
  }
  if (hopscotch.getCurrStepNum() == 4 && elEvents.interiorDoor >= 1) { //inner door
    hopscotch.nextStep();
    clearStates();
  }
  if (hopscotch.getCurrStepNum() == 5 && elEvents.roofPlacement >= 1) { //inner door
    console.log("roof placement done in tour");
    hopscotch.nextStep();
    enableAllControls();
    //clearStates();
  }

});